import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ProductCard from '../../components/molecules/ProductCard/ProductCard';
import { products } from '../../data/mockData';
import styles from './CollectionsPage.module.css';

const CollectionsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    const cat = searchParams.get('category');
    if (cat === 'men') setFilter("Men's Wear");
    else if (cat === 'women') setFilter("Women's Wear");
    else if (cat === 'kids') setFilter("Kids' Wear");
    else if (cat === 'ethnic') setFilter("Ethnic Wear");
    else setFilter('All');
  }, [searchParams]);

  const handleFilter = (type) => {
    setFilter(type);
    
    // Reverse map to URL parameter
    if (type === "Men's Wear") setSearchParams({ category: 'men' });
    else if (type === "Women's Wear") setSearchParams({ category: 'women' });
    else if (type === "Kids' Wear") setSearchParams({ category: 'kids' });
    else if (type === "Ethnic Wear") setSearchParams({ category: 'ethnic' });
    else setSearchParams({});
  };

  const filteredProducts = filter === 'All' 
    ? products 
    : products.filter(p => p.category === filter);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <div className="container">
          <h1 className="heading-xl">Our Collections</h1>
          <p className="text-body text-dim">Browse our premium wholesale collections</p>
        </div>
      </header>

      <section className={styles.content}>
        <div className="container">
          <div className={styles.filters}>
            <button 
              className={`${styles.filterBtn} ${filter === 'All' ? styles.active : ''}`}
              onClick={() => handleFilter('All')}
            >
              All
            </button>
            <button 
              className={`${styles.filterBtn} ${filter === "Men's Wear" ? styles.active : ''}`}
              onClick={() => handleFilter("Men's Wear")}
            >
              Men's Wear
            </button>
            <button 
              className={`${styles.filterBtn} ${filter === "Women's Wear" ? styles.active : ''}`}
              onClick={() => handleFilter("Women's Wear")}
            >
              Women's Wear
            </button>
            <button 
              className={`${styles.filterBtn} ${filter === "Kids' Wear" ? styles.active : ''}`}
              onClick={() => handleFilter("Kids' Wear")}
            >
              Kids' Wear
            </button>
            <button 
              className={`${styles.filterBtn} ${filter === "Ethnic Wear" ? styles.active : ''}`}
              onClick={() => handleFilter("Ethnic Wear")}
            >
              Ethnic Wear
            </button>
          </div>

          <div className={styles.grid}>
            {filteredProducts.map((product) => (
              <div key={product.id} className={styles.cardWrapper}>
                <Link 
                  to={`/enquiry?product=${encodeURIComponent(product.collection)}&sku=${product.sku}`} 
                  className={styles.linkOverlay} 
                  aria-label={`Enquiry for ${product.collection}`} 
                />
                <ProductCard {...product} />
              </div>
            ))}
          </div>
          
          {filteredProducts.length === 0 && (
            <div className={styles.noResults}>
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default CollectionsPage;
